if (!customElements.get('product-sticky-add')) {
  customElements.define(
    'product-sticky-add',
    class ProductStickyAdd extends HTMLElement {
      constructor() {
        super();

        this.formId = this.dataset.productFormId;
        this.productSectionId = `MainProduct-${this.dataset.section}`;

        this.button = this.querySelector('button');
        this.form = document.getElementById(this.formId);
        this.productSection = document.getElementById(this.productSectionId);
        
        this.mqlSmall = window.matchMedia('(max-width: 749px)');
        this.observer = null;
        
        this.button.addEventListener('click', this.addProduct.bind(this));
      }

      connectedCallback() {
        this.mqlSmall.addEventListener('change', this.onQueryChange.bind(this));
        if (this.mqlSmall.matches) this.setupObserver();
      }

      disconnectedCallback() {
        this.destroyObserver();       
      }

      setupObserver() {
        this.observer = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            this.classList.toggle('active', !entry.isIntersecting);
          },
          {
            root: null,
            threshold: 0.1,
          }
        );

        if (this.productSection) {
          this.observer.observe(this.productSection);
        }
      }

      destroyObserver() {
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
      }

      onQueryChange(media) {
        if (media.matches) {
          this.setupObserver();
        } else {
          this.destroyObserver();
        }
      }

      addProduct() {
        window.scrollTo({ 
          top: 0, behavior: 'smooth' 
        });

        this.form.dispatchEvent(
          new Event('submit', { 
            bubbles: true, cancelable: true 
          })
        );   
      }
      
    }
  )
}